import React from 'react';
import styles from '../../Payments.module.css';
import { CheckIcon } from '../../icons';

const left = [
  'Secure, encrypted checkout (256-bit SSL)',
  'PCI-compliant processing',
  'Saved payment methods',
  'Refunds in a click',
];

const right = [
  'Automatic receipts',
  'One clear statement descriptor',
  'Hosted payment pages & links',
  'Built-in chargeback protection',
];

const Capabilities = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />All the details</span>
        <h2>Everything in Fyntiq payments.</h2>
      </div>
      <div className={`${styles.capabilitiesGrid} ${styles.sr}`} data-sr>
        <ul className={styles.fList}>
          {left.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
        <ul className={styles.fList}>
          {right.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
      </div>
    </div>
  </section>
);

export default Capabilities;
